import React from 'react';
import SidebarComponent from './SidebarComponent';
import PageHeader from './PageHeader';

const WaterTreatmentPlants: React.FC = () => {
  return (
    <>

      <PageHeader title="Water Treatment Plants" />


      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-4.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">Water Treatment Plants</h1>
              <p>At WTIL, we specialize in the design, construction, and commissioning of high-efficiency Water
                Treatment Plants tailored to diverse industrial and municipal needs. Our systems are engineered
                to ensure optimal water purification, minimal operational cost, and long-term reliability. From
                conventional filtration units to fully automated treatment trains, we deliver end-to-end
                solutions that comply with stringent quality and environmental standards.</p>

              <p className="mb-5">Our focus lies in providing <strong>high-performance, reliable, and eco-conscious
                treatment solutions</strong>. With a team of skilled engineers, project managers, and
                service professionals, WTIL ensures smooth execution, operational efficiency, and long-term
                value for every plant we deliver.</p>

              <h3 className="mb-4">Our Capabilities Include:</h3>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Turnkey Design and supply of Water
                Treatment Plants (Civil, Mechanical, Electrical)</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Pre-treatment, filtration, softening,
                disinfection, and polishing systems</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Process & Utility Water Treatment</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Customized based on raw water
                characteristics</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>Integration with automation & SCADA
                systems</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>System Revamps and Capacity
                Enhancements</p>
              <p><i className="fa fa-hand-holding-water text-primary me-2"></i>O&amp;M and Technical Support</p>

              <h3 className="mb-4">Treatment Technologies and Products offered:</h3>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Clarifiers</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Tube Settlers & Pressure Sand Filters</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Iron, Fluoride, and Organics Removal
                Filters</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Activated Carbon & Self-Cleaning Filters
              </p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Micron Cartridge Filters & Polishing Units
              </p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Softeners, Deionization & Mixed Bed Units
              </p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Condensate Polishers & Side-Stream Filters
              </p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Reverse Osmosis (RO) systems</p>
              <p><i className="fa fa-project-diagram text-primary me-2"></i>Ultra filtration (UF) System</p>
              <p className="mb-5">Backed by decades of field experience across power, cement, textile, and municipal
                sectors, WTIL offers reliable water treatment systems that meet stringent regulatory standards
                while reducing lifecycle costs.</p>
            </div>

            <div className="col-lg-4">
              <SidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default WaterTreatmentPlants;
